const slideshow = document.querySelectorAll('.js-slideshow')
if (slideshow) {
  const clones = document.querySelectorAll('.js-slideshow-clone')
  clones.forEach((elm) => {
    const count = parseInt(elm.dataset.count ?? 1)
    for (let i = 0; i < count; i++) {
      elm.parentNode.append(elm.cloneNode(true))
    }
  })

  let delta = performance.now()
  const update = () => {
    const now = performance.now()
    const dt = (now - delta) / 60
    delta = now

    slideshow.forEach((elm) => {
      const speedPC = parseFloat(elm.dataset.speed ?? 1)
      const speedSP = parseFloat(elm.dataset.speedSp ?? speedPC)
      const speed = document.documentElement.clientWidth > 768 ? speedPC : speedSP

      let x = parseFloat(elm.dataset.x ?? 0)

      x += speed * dt
      if (elm.clientWidth / 2 <= x) {
        x -= elm.clientWidth / 2
      }

      const rev = elm.dataset.dir == 'rev'
      const px = !rev ? x : elm.clientWidth - document.documentElement.clientWidth - x

      elm.style.willChange = 'transform'
      elm.style.transform = `translate3d(-${px}px, 0, 0)`
      elm.dataset.x = x
    })

    requestAnimationFrame(update)
  }
  update()
}
